import type { WhatsAppTemplateDto } from "@multi-chat/shared";
import type { TemplateManagementSheetMode } from "./template-management/TemplateManagementSheet/index.js";

export interface TemplateListActionState {
  sheetOpen: boolean;
  sheetMode: TemplateManagementSheetMode | null;
  deleteTarget: WhatsAppTemplateDto | null;
}

export const initialTemplateListActionState: TemplateListActionState = {
  sheetOpen: false,
  sheetMode: null,
  deleteTarget: null,
};

export function openTemplateListCreate(
  state: TemplateListActionState,
): TemplateListActionState {
  return {
    ...state,
    sheetMode: { kind: "create" },
    sheetOpen: true,
  };
}

export function openTemplateListDuplicate(
  state: TemplateListActionState,
  template: WhatsAppTemplateDto,
): TemplateListActionState {
  return {
    ...state,
    sheetMode: { kind: "duplicate", template },
    sheetOpen: true,
  };
}

export function openTemplateListEdit(
  state: TemplateListActionState,
  template: WhatsAppTemplateDto,
): TemplateListActionState {
  return {
    ...state,
    sheetMode: { kind: "edit", template },
    sheetOpen: true,
  };
}

export function setTemplateListSheetOpen(
  state: TemplateListActionState,
  open: boolean,
): TemplateListActionState {
  return {
    ...state,
    sheetOpen: open,
  };
}

export function requestTemplateListDelete(
  state: TemplateListActionState,
  template: WhatsAppTemplateDto,
): TemplateListActionState {
  return {
    ...state,
    deleteTarget: template,
  };
}

export function cancelTemplateListDelete(
  state: TemplateListActionState,
): TemplateListActionState {
  return {
    ...state,
    deleteTarget: null,
  };
}
